import { createStyles } from 'antd-style';

import { ThemeColors, ThemeSpaces } from '../theme';

export const useUploadDropAreaStyles = createStyles(({ token }) => ({
  fileUploadContainer: {
    '> *': {
      display: 'block',
    },
  },
  fileUpload: {
    '&.ant-upload.ant-upload-drag': {
      borderRadius: 0,
      border: `2px dashed ${ThemeColors.COLOR_GREY8_1}`,
      backgroundColor: ThemeColors.COLOR_WHITE,

      '.ant-upload.ant-upload-btn': {
        padding: 0,
        display: 'block',
      },

      '.ant-upload-drag-container': {
        display: 'block',
        padding: `${ThemeSpaces.SPACE_NORM_50}px 0`,
        whiteSpace: 'pre-line',
        fontSize: token.fontSizeHeading4,
        lineHeight: '21.5px',
      },

      '+ .ant-upload-list': {
        marginTop: ThemeSpaces.SPACE_NORM_20,
        '&:empty': {
          marginTop: 0,
        },

        '.ant-upload-list-text-container': {
          marginBottom: ThemeSpaces.SPACE_NORM,
          '&:last-child': {
            marginBottom: 0,
          },
        },
      },
    },
  },
}));
